var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.185,
    height: 19.087,
    viewBox: "0 0 21.185 19.087",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#78849e;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.06 0.967)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.5,6v5.788H7.288",
    transform: "translate(-1.5 -5.044)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.921,16.081A8.682,8.682,0,1,0,5.976,7.052L1.5,11.257",
    transform: "translate(-1.5 -4.514)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.9b190a9af8b549d82845a91a4a7882e0.svg";
export { ForwardRef as ReactComponent };